export default "__VITE_ASSET__BiU2$oor__"